import React from 'react';
import { SupervisorAccount, UserGear, Person, Users } from '@insurancemenu/imenu-components-lib/dist/icons';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import colors from '@insurancemenu/imenu-components-lib/dist/utils/colors';

export interface RateSegmentInfo {
  label: string;
  icon: JSX.Element;
  order: number;
  title: string;
}

type RateSegmentINFO = {
  [K in RateSegment]: RateSegmentInfo;
};

export const RATE_SEGMENT_INFO: RateSegmentINFO = Object.freeze({
  GROUP: {
    label: 'Small Employer',
    icon: <SupervisorAccount width="10rem" height="10rem" color={colors.blue[600]} />,
    order: 1,
    title: 'Select a product type from the Small Group catalog.',
  },
  CUSTOM: {
    label: 'Large Employer',
    icon: <UserGear width="10rem" height="10rem" color={colors.blue[600]} />,
    order: 2,
    title: 'Select a product type from the RFQ catalog.',
  },
  ASSOCIATION: {
    label: 'Public Sector/Associations',
    icon: <Users width="10rem" height="10rem" color={colors.blue[600]} />,
    order: 3,
    title: 'Select a product type from the Association catalog.',
  },
  INDIVIDUAL: {
    label: 'Individual',
    icon: <Person width="10rem" height="10rem" color={colors.blue[600]} />,
    order: 4,
    title: '',
  },
  LEVEL: {
    label: 'Level Funded',
    icon: <UserGear width="10rem" height="10rem" color={colors.blue[600]} />,
    order: 5,
    title: '',
  },
});
